import UserCard from './container';

export default UserCard;



// WEBPACK FOOTER //
// ./src/components/Steps/UserCard/index.js